/**
 * Centralized Environment Configuration
 * 
 * WHY: Abstracting 'import.meta.env' allows src/services to be
 * portable to environments that don't use Vite (e.g., React Native/Metro).
 */

const getEnvVar = (key: string, defaultValue: string = ''): string => {
    // Safe access for Vite environment
    if (typeof import.meta !== 'undefined' && import.meta.env) {
        return (import.meta.env[key] as string) || defaultValue;
    }
    return defaultValue;
};

const isDev = (): boolean => {
    if (typeof import.meta !== 'undefined' && import.meta.env) {
        return import.meta.env.DEV || import.meta.env.MODE === 'development';
    }
    return false;
};

const isTest = (): boolean => {
    if (typeof import.meta !== 'undefined' && import.meta.env) {
        return import.meta.env.MODE === 'test';
    }
    return false;
};

export const Config = {
    // Core
    isDev: isDev(),
    isTest: isTest(),
    mode: typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env.MODE : 'production',

    // Firebase
    firebase: {
        apiKey: getEnvVar('VITE_FIREBASE_API_KEY'),
        authDomain: getEnvVar('VITE_FIREBASE_AUTH_DOMAIN'),
        projectId: getEnvVar('VITE_FIREBASE_PROJECT_ID'),
        storageBucket: getEnvVar('VITE_FIREBASE_STORAGE_BUCKET'),
        messagingSenderId: getEnvVar('VITE_FIREBASE_MESSAGING_SENDER_ID'),
        appId: getEnvVar('VITE_FIREBASE_APP_ID'),
    },

    // Stripe
    stripe: {
        publishableKey: getEnvVar('VITE_STRIPE_PUBLISHABLE_KEY'),
        // Demo/QA firms route to Stripe TEST on the backend, so their card entry must
        // tokenize with a TEST publishable key. Optional ('' when unset).
        publishableKeyTest: getEnvVar('VITE_STRIPE_PUBLISHABLE_KEY_TEST'),
    },

    // Integrations
    emailit: {
        apiUrl: getEnvVar('VITE_EMAILIT_API_URL'),
        publicKey: getEnvVar('VITE_EMAILIT_PUBLIC_KEY'),
    },
};
